export default "__VITE_ASSET__d68dc4f7__"